'use client'

import { useTranslations } from 'next-intl'
import React from 'react'

import { ZEditorJsRenderer } from '@/_components/universal/editorjs-renderer'
import { LIST_STYLE_ENUM } from '@/_components/universal/editorjs-renderer/components/b-editorjs-nested-list'
import ZCategoryNavigation from '@/_components/universal/z-category-navigation'
import { useSectionParams } from '@/_i18n/section-params'
import { IAPCategory } from '@/_types'

import AAPCategoryFamilySelect from './category-family/a-ap-category-family-select'

interface IProps {
	annualPrograms: IAPCategory[]
}

const AAPCategoryFamily = ({ annualPrograms }: IProps) => {
	const t = useTranslations('pages.apCategories')
	const { getSectionParams } = useSectionParams('annualPrograms')
	return (
		<section
			id={`${getSectionParams('annualProgramCategory')}-rodina`}
			className='box_complex-health bg_complex-health4 pdt-100 pdt-30lg pdb-100 pdb-60lg pos_rel'
		>
			<div className='wrapper dflex_lgm flex-dir-column'>
				<div className='box_complex-health mgt-0 mgt-10lg'>
					<div className='anim_delay anim_drop1 observe'>
						<h2 className='title_h1'>{t('family_programs.title')}</h2>
						<div className='page_content reset_margins mgt-30'>
							<p>
								{t.rich('family_programs.description', {
									b: chunks => <b>{chunks}</b>
								})}
							</p>
						</div>
					</div>
				</div>
				<ZCategoryNavigation
					categories={annualPrograms}
					activeCategory={'rodina'}
					useHash={true}
					hashPrefix={`${getSectionParams('annualProgramCategory')}-`}
				/>
				<div className='order-last'>
					<div className='page_content reset_margins mgt-50 nobalance'>
						<ZEditorJsRenderer
							className='!pb-1'
							data={{
								blocks: [
									{
										type: 'paragraph',
										data: {
											text: 'Členom vašej rodiny aktuálne ponúkame rodinnú zľavu 10% na naše ročné programy. Zľavu si môžete uplatniť z celkovej základnej ceny programu pri výbere aspoň dvoch programov. Podmienkou je byť v blízkej priamej rodinnej väzbe (napríklad. manželia, súrodenci, rodičia).'
										}
									},
									{
										type: 'nestedList',
										data: {
											style: LIST_STYLE_ENUM.UNORDERED,
											items: [
												{
													content:
														'Zľava sa každoročne automaticky obnovuje pri predĺžení programov, alebo pri pridaní ďalšieho člena rodiny – platí počas celého trvania aspoň jedného programu v rodine. '
												},
												{
													content:
														'Flexibilne si nakombinujte programy pre dospelých aj deti.'
												},
												{
													content:
														'Spojte starostlivosť o zdravie celej rodiny s našimi odborníkmi a získajte komplexnú starostlivosť na mieru, kedykoľvek ju potrebujete. '
												}
											]
										}
									}
								]
							}}
						/>
					</div>
				</div>
				<AAPCategoryFamilySelect annualPrograms={annualPrograms} />
			</div>
		</section>
	)
}

export default AAPCategoryFamily
